module.exports = __webpack_public_path__ + "media/images/steps/step_3-2c32f4274f4ba76838e0c1a4d0cb0fe5.svg";